module.exports = __webpack_public_path__ + "img/example5.8e7ec202.jpg";